import { render } from "./BonusEndScreen.vue?vue&type=template&id=01606110&scoped=true"
import script from "./BonusEndScreen.vue?vue&type=script&lang=js"
export * from "./BonusEndScreen.vue?vue&type=script&lang=js"

import "./BonusEndScreen.vue?vue&type=style&index=0&id=01606110&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01606110"]])

export default __exports__